module.exports = __webpack_public_path__ + "static/media/example_symm1.7ba02293.bmp";